console.log('js/responsive_images.js -> v0.1.0');

$(function() {

    var type = 'sm';
    if($(window).width() >= 768 && $(window).width() < 1024){
        type = 'md';
    }else if($(window).width() >= 1024){
        type = 'lg';
    };
    
    $('.js-responsive').each(function(){
        if($(this).attr('data-responsive-img-'+type)){
            $(this).append('<img src="'+$(this).attr('data-responsive-img-'+type)+'">');
        }else if($(this).attr('data-responsive-bg-'+type)){
            $(this).css('background','center no-repeat url('+$(this).attr('data-responsive-bg-'+type)+')').css('background-size','cover');
        };
    });

});
